import React, { Component } from "react"
import PropTypes from "prop-types"
import defaultVideoPlaceholder from "../images/no-video.png"

const getVideoId = link => {
  // Only extracts youtube id without additional query params
  // Same as we do in email editor here packages/editor-v2/src/plugins/video-plugin/utils/helpers.js
  return link.match(/(\w|-){11}/)?.[0] || ""
}

export const createYouTubeEmbedURL = src => {
  const videoId = getVideoId(src)
  if (!videoId) return ""

  try {
    const srcURL = new URL(src)

    const timestamp = srcURL.searchParams.get("t")
    const url = new URL("https://www.youtube.com/embed/" + videoId)
    if (timestamp) {
      url.searchParams.set("start", timestamp.replace("s", ""))
    }
    url.searchParams.set("autoplay", "0")
    url.searchParams.set("color", "white")
    url.searchParams.set("modestbranding", "1")
    url.searchParams.set("rel", "0")
    return url.toString()
  } catch {
    return ""
  }
}

class VideoElement extends Component {
  static propTypes = {
    className: PropTypes.string,
    editing: PropTypes.bool,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    src: PropTypes.string,
    style: PropTypes.object
  }

  render() {
    const { src, editing } = this.props

    return src ? (
      <div
        className={`formkit-video ${this.props.className}`}
        onClick={this.props.onClick}
        onKeyPress={e => {
          if (e.key === "Enter") {
            this.props.onClick()
          }
        }}
        role="button"
        tabIndex="0"
      >
        <div
          className="formkit-video-frame"
          style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}
        >
          {editing && <div className="absolute inset-0 z-50" />}
          <iframe
            title="video"
            width="2560"
            height="1440"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              left: "0px",
              top: "0px"
            }}
            src={createYouTubeEmbedURL(src)}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    ) : editing ? (
      <div
        className={this.props.className}
        onClick={this.props.onClick}
        onKeyPress={e => {
          if (e.key === "Enter") {
            this.props.onClick()
          }
        }}
        role="button"
        tabIndex="0"
      >
        <img
          src={defaultVideoPlaceholder}
          alt="video placeholder"
          style={{ minWidth: "100%" }}
        />
      </div>
    ) : null
  }
}

export { VideoElement }
